<div class="flex h-screen bg-gray-50 overflow-hidden">

  <!-- Sidebar -->
  <app-menu></app-menu>

  <!-- Mobile backdrop: dims content and closes sidebar on tap -->
  @if (state.isMobile() && state.sidebarOpen()) {
    <div class="sidebar-backdrop" (click)="state.closeSidebar()"></div>
  }

  <!-- Main area (shifts with sidebar on desktop, stays full-width on mobile since sidebar overlays) -->
  <div class="flex flex-col flex-1 overflow-hidden"
       [style.marginLeft]="(!state.isMobile() && state.sidebarOpen()) ? '256px' : '0px'"
       style="transition: margin-left 0.3s ease;">

    <!-- Top bar -->
    <app-header></app-header>

    <!-- Scrollable page content (offset by header height) -->
    <main class="flex-1 overflow-y-auto" style="padding-top: 64px; background: #f8fafc;">
      <router-outlet></router-outlet>
    </main>

    <!-- Footer -->
    <app-footer></app-footer>

  </div>

</div>
